import React from "react";

export interface ExemptionDetailWrapperProps {
  title: string;
  children: React.ReactNode;
}

const ExemptionDetailWrapper = (props: ExemptionDetailWrapperProps) => {
  const { title, children } = props;

  return (
    <>
      <div className="bg-secondary px-4 px-lg-5 py-3 rounded-top text-white">
        <span className="font-size-lg font-weight-bold">{title}</span>
      </div>
      <div className="bg-light mb-4 px-4 px-lg-5 pt-4 pb-2 rounded-bottom">{children}</div>
    </>
  );
};

export default ExemptionDetailWrapper;
